import React from 'react';
import { LibraryPage } from './LibraryPage';
import { maintenanceLibrary } from '../../library/maintenanceLibrary';

/** Superadmin page for the maintenance activity library. */
const MaintenanceLibraryPage: React.FC = () => <LibraryPage config={maintenanceLibrary} />;

export default MaintenanceLibraryPage;
